import * as msg from '../../helpers/console'
import deleteUserConfirm from '../../components/deleteUserConfirm'

const init = () => {
  msg.success('EditUsersController', 'Ready!')
  new deleteUserConfirm().init();
}

export default init
